export const state = () => ({
  wishlist: {
    items: [],
    total: 0,
    loaded: false
  }
})

export const getters = {
  WISHLIST: state => state.wishlist,
  WISHLIST_LENGTH: state => state.wishlist.items.length,
  WISHLIST_LOADED: state => state.wishlist.loaded
}

export const actions = {
  async GET(vuexContext) {
    try {
      const data = await this.$axios.$get('favourite')

      if (data?.items) {
        vuexContext.commit('SET', data)
        return Promise.resolve()
      } else {
        return Promise.reject('Wishlist getting server error')
      }
    } catch (err) {
      return Promise.reject('Wishlist getting server error')
    }
  },

  async GET_TOTAL(vuexContext) {
    try {
      const data = await this.$axios.$get('favourite')

      if (data?.total) {
        vuexContext.commit('SET_TOTAL', data.total)
        return Promise.resolve()
      } else {
        return Promise.reject('Wishlist getting server error')
      }
    } catch (err) {
      return Promise.reject('Wishlist getting server error')
    }
  },

  async ADD(vuexContext, { id, unit, quantity = 1, configurations = [] }) {
    try {
      const data = await this.$axios.$post('favourite', {
        id,
        unit,
        quantity,
        configurations
      })

      if (data?.items) {
        vuexContext.commit('SET', data)
        return Promise.resolve(data)
      } else {
        return Promise.reject('Wishlist adding server error')
      }
    } catch (err) {
      return Promise.reject('Wishlist adding server error')
    }
  },

  async REMOVE(vuexContext, { id, unit }) {
    try {
      const data = await this.$axios.$delete('favourite', {
        data: {
          id,
          unit
        }
      })

      if (data?.result) {
        vuexContext.commit('REMOVE_BY_ID', id)
        return Promise.resolve()
      } else {
        return Promise.reject('Wishlist removing server error')
      }
    } catch (err) {
      return Promise.reject('Wishlist removing server error')
    }
  },
}

export const mutations = {
  SET: (state, wishlist) => {
    state.wishlist.items = wishlist.items
    state.wishlist.total = wishlist.total
    state.wishlist.loaded = true
  },

  SET_TOTAL: (state, total) => {
    state.wishlist.total = total
  },

  REMOVE_BY_ID: (state, id) => {
    state.wishlist.items = state.wishlist.items.filter(item => item.id !== id)
  },

  SET_QUANTITY: (state, { id, quantity }) => {
    const product = state.wishlist.items.find(item => item.id === id)

    if (product) {
      product.quantity.current = quantity
    }
  }
}